export default "__VITE_ASSET__to3EHLm8__"